import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import Home from './pages/home';
import Profile from './pages/profile';
import Signup from './pages/signup';
import AllMemberArea from "./routes/NotLoggedIn";
import LoggedInRedirect from './routes/LoggedIn';
import ProformaInvoice from './pages/proformainvoice';
import PIList from './pages/PIList';
import PaidInvoiceList from './pages/PaidInvoiceList';
import PIListToPaidList from './pages/PIListToPaidList';
import KontrakList from './pages/ListKontrak';
import KontrakListTemp from './pages/ListKontrakTemp';
import Template from './pages/template';
import AddAddress from './pages/add-address';
import AddJumlah from './pages/add-jumlah'
import CreatePost from './pages/create-post'
import ViewPost from './pages/view-post'
import CreateKontrak from './pages/Kontrak/createKontrak'
import ContractDialog from './pages/ContractDialog'
import PrivateOfficeManagement from './pages/PrivateOfficeManagement'
import Domisili from './pages/Domisili'
import ConfirmSignature from './pages/ConfirmSignature'
import DomisiliKokas from './pages/DomisiliKokas'
import ListInquiry from './pages/ListInquiry'
import NewInquiry from './pages/NewInquiry'
import NewBooking from './pages/NewBooking'
import Calendar from './pages/Calendar'
import EditInquiry from './pages/EditInquiry'
import ListMail from './pages/ListMail'
import NewMail from './pages/NewMail'
import NewCall from './pages/NewCall'
import ListCompany from './pages/ListCompany'
import ListKlien from './pages/ListKlien'
import EditCompany from './pages/EditCompany'
import EditKlien from './pages/EditKlien'
import ListCall from './pages/ListCall'
import ListNotifikasi from './pages/ListNotifikasi'
import ListDedicatedCall from './pages/ListDedicatedCall'
import PulsaManagement from './pages/PulsaManagement'
import useMediaQuery from '@mui/material/useMediaQuery';
import CalendarMobile from './pages/CalendarMobile';
import SuratPengajuanDialog from './pages/SuratPengajuanDialog'
import ConfirmSignatureMobile from './pages/ConfirmSignatureMobile'
import SalesMobile from './pages/SalesMobile'
import LegalProcess from './pages/LegalProcess'
import PaidInvoiceMobile from './pages/PaidInvoiceMobile'
import KonfirmasiTransaksi from './pages/KonfirmasiTransaksi'
import SalesMeeting from './pages/SalesMeeting'
import SpecificCase from './pages/SpecificCase'
import SpecificRandomizer from './pages/specificrandomizer'
import SalesReview from './pages/SalesReview'
import InquiryReview from './pages/InquiryReview'
import ExpiringKontrak from './pages/ExpiringKontrak'
import CekPIC from './pages/CekPIC';
import SalesReviewStage1 from './pages/SalesReviewStage1';
import SalesReviewStage2 from './pages/SalesReviewStage2';
import MarketingCreate from './pages/MarketingCreate';
import MarketingReview from './pages/MarketingReview';
import Whatsappclone from './pages/whatsappclone';
import SonarReview from './pages/SonarReview';
import TaskToDo from "./module/TaskToDo";
import LegalToDoList from "./pages/legalToDoList";
import LegalStagesEdit from "./pages/legalStagesEdit";
import InquiryAdminV2 from "./pages/InquiryAdminV2";


import { useSelector } from 'react-redux';


// ===== Optionally Create or Import a "SalesMobileUpdate" Page =====
// If you haven't yet created one, here's a basic placeholder:
function SalesMobileUpdate() {
  return <h1>Sales Mobile Update Page</h1>;
}

// If you have a Redux store or global context to get user info:

export default function App() {
  // If you're using Redux:
  const nowstate = useSelector((state) => state);

  // If the user object is nested differently, adjust accordingly.
  // e.g. if your user is at nowstate.user.role
  const currentUserRole = nowstate?.user?.role || 'visitor';

  const isMobileDevice = useMediaQuery('(max-device-width: 600px)');

  return (
    <Routes>
      {/* Protect login if user is already logged in */}
      <Route element={<LoggedInRedirect />}>
        <Route path="/login" element={<Login />} exact />
      </Route>

      {/* Public or direct routes */}
      <Route path="/contract/:id" element={<ContractDialog />} />
      <Route path="/suratpengajuan/:id" element={<SuratPengajuanDialog />} />

      {/* App area where user must be logged in */}
      <Route element={<AllMemberArea />}>
        {/* If user is on MOBILE */}
        {isMobileDevice ? (
          <>
            {/* 
              Conditionally set the default home route 
              to SalesMobileUpdate IF user.role === "sales" 
              otherwise CalendarMobile
            */}
            {currentUserRole === 'sales' ? (
              <Route path="/*" element={<Navigate to="/SalesMobile" />} />
            ) : (
              <Route path="/*" element={<Navigate to="/CalendarMobile" />} />
            )}

            {/* 
              Define your mobile-only routes:
              Notice we also define the route for "/SalesMobileUpdate" 
              so we can actually navigate there
            */}
            <Route path="/SalesMobileUpdate" element={<SalesMobileUpdate />} />
            <Route path="/CalendarMobile" element={<CalendarMobile />} />
            <Route path="/ConfirmSignatureMobile" element={<ConfirmSignatureMobile />} />
            <Route path="/PaidInvoiceMobile" element={<PaidInvoiceMobile />} />
            <Route path="/SalesMobile" element={<SalesMobile />} />
          </>
        ) : (
          // If user is NOT on mobile, display your usual web routes
          <>
            <Route path="/InquiryAdminV2" element={<InquiryAdminV2 />} />
            <Route path="/CalendarMobile" element={<Navigate to="/Calendar" />} />
            <Route path="/profile" element={<Profile />} exact />
                        <Route path="/legaltodolist" element={<LegalToDoList />} exact />
                                                <Route path="/legalstagesedit" element={<LegalStagesEdit />} exact />
            <Route path="/specificrandomizer" element={<SpecificRandomizer />} exact />
            <Route path="/" element={<Home />} exact />
            <Route path="/signup" element={<Signup />} exact />
            <Route path="/proformainvoice" element={<ProformaInvoice />} exact />
            <Route path="/pi-list" element={<PIList />} exact />
            <Route path="/kontrak" element={<KontrakList />} exact />
            <Route path="/template" element={<Template />} exact />
            <Route path="/add-address" element={<AddAddress />} exact />
            <Route path="/add-jumlah" element={<AddJumlah />} exact />
            <Route path="/create-post" element={<CreatePost />} exact />
            <Route path="/view-post" element={<ViewPost />} exact />
            <Route path="/create-kontrak" element={<CreateKontrak />} exact />
            <Route path="/paid-invoice-list" element={<PaidInvoiceList />} exact />
            <Route path="/PIListToPaidList" element={<PIListToPaidList />} exact />
            <Route path="/PrivateOfficeManagement" element={<PrivateOfficeManagement />} exact />
            <Route path="/KonfirmasiTransaksi" element={<KonfirmasiTransaksi />} />
            <Route path="/kontraktemp" element={<KontrakListTemp />} exact />
            <Route path="/whatsappclone" element={<Whatsappclone />} exact />
            <Route path="/domisili" element={<Domisili />} exact />
            <Route path="/domisilikokas" element={<DomisiliKokas />} exact />
            <Route path="/ConfirmSignature" element={<ConfirmSignature />} exact />
            <Route path="/ListInquiry" element={<ListInquiry />} exact />
            <Route path="/new-inquiry" element={<NewInquiry />} exact />
            <Route path="/edit-inquiry" element={<EditInquiry />} exact />
            <Route path="/ListMail" element={<ListMail />} exact />
            <Route path="/NewMail" element={<NewMail />} exact />
            <Route path="/CompanyList" element={<ListCompany />} exact />
            <Route path="/edit-Company" element={<EditCompany />} exact />
            <Route path="/ListKlien" element={<ListKlien />} exact />
            <Route path="/Edit-Klien" element={<EditKlien />} exact />
            <Route path="/NewCall" element={<NewCall />} exact />
            <Route path="/ListCall" element={<ListCall />} exact />
            <Route path="/ListNotifikasi" element={<ListNotifikasi />} exact />
            <Route path="/NewBooking" element={<NewBooking />} exact />
            <Route path="/Calendar" element={<Calendar />} exact />
            <Route path="/SalesReviewStage1" element={<SalesReviewStage1 />} exact />
            <Route path="/SonarReview" element={<SonarReview />} exact />
            <Route path="/SalesReviewStage2" element={<SalesReviewStage2 />} exact />
            <Route path="/DedicatedCall" element={<ListDedicatedCall />} exact />
            <Route path="/PulsaManagement" element={<PulsaManagement />} exact />
            <Route path="/LegalProcess" element={<LegalProcess />} exact />
            <Route path="/MarketingCreate" element={<MarketingCreate />} exact />
            <Route path="/MarketingReview" element={<MarketingReview />} exact />
            <Route path="/SalesMeeting" element={<SalesMeeting />} exact />
            <Route path="/specificcase" element={<SpecificCase />} exact />
            <Route path="/salesreview" element={<SalesReview />} exact />
            <Route path="/inquiryreview" element={<InquiryReview />} exact />
            <Route path="/expiringkontrak" element={<ExpiringKontrak />} exact />
            <Route path="/cekpic" element={<CekPIC />} exact />
          </>
        )}
      </Route>
    </Routes>
  );
}
